import { getFilename } from '../pages/file-list/format';

export async function downloadFile(token: string, filename: string) {
  try {
    const { downloadFileURL } = (window as any).data.download;
    const response = await fetch(downloadFileURL, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      body: JSON.stringify({
        file_name: filename,
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to trigger download: ${response.statusText}`);
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${getFilename(filename)}`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Error in triggerDownload:', error);
  }
}
